import script from "./SidebarMenuLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenuLink.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenuLink.vue?vue&type=style&index=0&id=e339089a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e339089a"]])

export default __exports__